import { render, staticRenderFns } from "./LiveChatDefaultQuestion.vue?vue&type=template&id=3e5b595e&scoped=true&"
import script from "./LiveChatDefaultQuestion.vue?vue&type=script&lang=js&"
export * from "./LiveChatDefaultQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatDefaultQuestion.vue?vue&type=style&index=0&id=3e5b595e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b595e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
